import React, { useState, Fragment, useEffect, useRef } from "react";

import "./style.css";
import data from "./mock-data.json";
import ReadOnlyRow from "./ReadOnlyRow";
import EditableRow from "./EditableRow";

import Cookies from "js-cookie";

import { Circles } from "react-loader-spinner";

import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

//receipt component
import Receipt from "../twRecords/receipts/Receipt";

import ClassPrinter from "../twRecords/receipts/ClassPrinter";

//pdf creator
import jsPDF from "jspdf";
// import "jspdf-autotable";

// import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

import { useSelector } from "react-redux";
import { fetchCompanies } from "../../../redux/companySlice";
import { useDispatch } from "react-redux";



const TwRecords = () => {
  const options = [
    { value: "", text: "-- choose product type --" },
    { value: "coffee", text: "coffee" },
    { value: "tea leaves", text: "tea leaves" },
    { value: "milk", text: "milk" },
  ];

  //store select company values in an array
  const companies = [
    { value: "", text: "-- select company--" },
    { value: "Terraweb", text: "Terraweb" },
    { value: "Gatamura Dairy", text: "Gatamura Dairy" },
    { value: "Mbuuni Coffee", text: "Mbuuni Coffee" },
    { value: "Kanyua Tea", text: "Kanyua Tea" },
  ];

  const [names, setNames] = useState({
    producttype: options[0].value,
    company: companies[0].value,
  });

  const [foundUsers, setFoundUsers] = useState();

  const [contacts, setContacts] = useState(data);
  const [addFormData, setAddFormData] = useState({
    id: "",
    fullname: "",
    farmerid: "",
    firstName: "",
    lastName: "",
    producttype: "",
    daterecorded: "",
    company: "",
    weight: "",
  });

  const [editFormData, setEditFormData] = useState({
    id: "",
    fullname: "",
    producttype: "",
    daterecorded: "",
    companyname: "",
    weight: "",
  });


  //dispatch companies from the redux store
  const dispatch = useDispatch();
      //fetch companies using get
      
      const companiesList = useSelector((state) => state.companies?.list || []);
    
    useEffect(() => {
      dispatch(fetchCompanies());
    }, [dispatch]);
    

  const [editContactId, setEditContactId] = useState(null);

  //lookup farmer id and set state to show labe if found
  const [foundFarmer, setFoundFarmer] = useState(null);

  //display success info after successful registration
  const [success, setSuccess] = useState("");

  const [foundErr, setFoundErr] = useState(null);
  const [foundErrAdd, setFoundErrAdd] = useState(null);
  const [isLoading, setIsLoading] = useState(null);
  const [isLoadingAdd, setIsLoadingAdd] = useState(null);
  const [isLoadingSave, setIsLoadingSave] = useState(null);

  //when record is successfully added
  const [successAdd, setSuccessAdd] = useState(null);

  //analysis Constants
  const [totalRecords, settotalRecords] = useState(null);

  //search users in your company
  const [searchRecord, setSearchRecord] = useState("");

  const [deleteState, setDeleteState] = useState("");

  //clear inputs
  const usernameRef = useRef();
  const emailRef = useRef();
  const passwordRef = useRef();

  //use ref to fill inputs or clear them
  const firtNameRef = useRef();
  const lastNameRef = useRef();

  //creating a fullname formatter here so that fullname data goes into the dataabase in the
  //form of firstname Lastname
  // Function to format the full name
  const formatFullName = (firstName, lastName) => {
    // Ensure the first letter of each name is capitalized
    const formattedFirstName =
      firstName.charAt(0).toUpperCase() + firstName.slice(1);
    const formattedLastName =
      lastName.charAt(0).toUpperCase() + lastName.slice(1);

    // Combine the formatted names into the full name
    const fullName = `${formattedFirstName} ${formattedLastName}`;

    return fullName;
  };

  //format the company to start with capital letter and remove white spaces
  // Function to format the company name
  const formatCompanyName = (input) => {
    // Remove leading and trailing white spaces
    const trimmedInput = input.trim();

    // Ensure the first letter is capitalized
    const formattedCompanyName =
      trimmedInput.charAt(0).toUpperCase() + trimmedInput.slice(1);

    return formattedCompanyName;
  };

  //handle product type input
  const onProducttypeChange = (event) => {
    // if (names.gender.length >= 1) {
    //   setFlag(1);
    // } else {
    //   setFlag(2);
    // }
    // Spreading "...state" ensures we don't "lose" fname,lname,email... etc
    setNames((names) => ({
      ...names,
      producttype: event.target.value,
    }));

    //update the form fields before updating
    event.preventDefault();

    const fieldName = event.target.getAttribute("name");
    const fieldValue = event.target.value;

    const newFormData = { ...addFormData };
    newFormData[fieldName] = fieldValue;

    setAddFormData(newFormData);
  };

  useEffect(() => {
    //fetch records
    const fetchAll = () => {
      try {
        let adminCookie = Cookies.get("sessionidadmin");
        let userCookie = Cookies.get("sessioniduser");
        if (adminCookie.length >= 8 || userCookie.length >= 8) {
          setIsLoading(true);

          setTimeout(() => {
            fetch("https://api.terraweb.africa/getTWRecords", {
              method: "post",
              headers: { "Content-Type": "application/JSON" },
              body: JSON.stringify({
                adminid: adminCookie,
                userid: userCookie,
              }),
            })
              .then(function (response) {
                if (response.status === 400) {
                  throw Error("Wrong credentials");
                }
                if (response === 500) {
                  throw Error("Could not complete request because of an error");
                }

                return response.json();
              })
              .then((user) => {
                if (user[0].id >= 1) {
                  setFoundErr(null);

                  setIsLoading(null);
                  setContacts(user);
                  // loadAnalysis(user);

                  //load data
                } else {
                  //dont load

                  setFoundErr(null);
                  setIsLoading(null);
                }
              })
              .catch((err) => {
                // setFoundErr(err.message);
                setIsLoading(null);
                // setFlag(1);
              });
          }, 2000);
        } else {
          setIsLoading(null);
        }
      } catch (error) {}
    };

    //load profile
    const fetchProfile = () => {
      let adminCookie = "";
      adminCookie = Cookies.get("sessionidadmin");
      let userid = "";
      userid = Cookies.get("sessioniduser");
      if (adminCookie.length >= 1 || userid.length >= 1) {
        setIsLoading(true);
        setTimeout(() => {
          fetch("https://api.terraweb.africa/loadProfile", {
            method: "post",
            headers: { "Content-Type": "application/JSON" },
            body: JSON.stringify({
              adminid: adminCookie,
              userid: userid,
            }),
          })
            .then(function (response) {
              if (response.status === 400) {
                throw Error("Wrong credentials");
              }
              if (response === 500) {
                throw Error("Could not complete request because of an error");
              }

              return response.json();
            })
            .then((user) => {
              if (user[0].username.length >= 1) {
                //load data

                setFoundErrAdd(null);

                setIsLoading(null);
                setContacts(user);

                setSuccess(null);
                setDeleteState(null);

                //store a name after load to display in the title of the users table
                setNames((names) => ({
                  ...names,
                  company: user[0].company,
                }));

                setAddFormData((prevState) => ({
                  ...prevState,
                  company: user[0].company,
                }));
              } else {
                //dont load

                setFoundErrAdd(null);
                setFoundErr(null);
                setIsLoading(null);
                setDeleteState(null);
              }
            })
            .catch((err) => {
              // setFoundErr(err.message);
              setIsLoading(null);
              // setFlag(1);
            });
        }, 150);
      } else {
        setIsLoading(null);
      }
    };

    fetchAll();
    fetchProfile();
  }, []);

  // timer for success and error message
  // Success/Error auto-hide after 8 seconds
  useEffect(() => {
    if (successAdd || foundErrAdd) {
      const timer = setTimeout(() => {
        setSuccessAdd("");
        setFoundErrAdd("");
      }, 8000);
  
      return () => clearTimeout(timer); // cleanup
    }
  }, [successAdd, foundErrAdd]);

  //load analysis
  const loadAnalysis = (datamap) => {};

  //search records
  const searchRecords = () => {
    // setContacts(null);
    //fetch cookie
    let adminCookie = Cookies.get("sessionidadmin");
    if (adminCookie.length >= 1) {
      setIsLoading(true);

      setTimeout(() => {
        fetch("https://api.terraweb.africa/searchRecords", {
          method: "post",
          headers: { "Content-Type": "application/JSON" },
          body: JSON.stringify({
            adminid: adminCookie,

            fullname: searchRecord,

            userid: searchRecord,
          }),
        })
          .then(function (response) {
            if (response.status === 400) {
              throw Error("Wrong credentials");
            }
            if (response === 500) {
              throw Error("Could not complete request because of an error");
            }

            return response.json();
          })
          .then((user) => {
            if (user[0].id >= 1) {
              setFoundErr(null);
              setFoundErrAdd(null);
              setDeleteState(null);

              setIsLoading(null);
              setContacts(user);
              loadAnalysis(user);

              //load data
            } else {
              //dont load

              setFoundErr(null);
              setFoundErrAdd(null);
              setIsLoading(null);
              setDeleteState(null);
            }
          })
          .catch((err) => {
            // setFoundErr(err.message);
            setIsLoading(null);
            // setFlag(1);
          });
      }, 1500);
    } else {
      setIsLoading(null);
    }
  };

  //handle search user
  const onSearchChange = (event) => {
    event.preventDefault();
    setSearchRecord(event.target.value);
  };

  //fetch users
  const fetchRecords = () => {
    try {
      let adminCookie = Cookies.get("sessionidadmin");
      let userCookie = Cookies.get("sessioniduser");
      if (adminCookie.length >= 8 || userCookie.length >= 8) {
        setIsLoading(true);

        setTimeout(() => {
          fetch("https://api.terraweb.africa/getTWRecords", {
            method: "post",
            headers: { "Content-Type": "application/JSON" },
            body: JSON.stringify({
              adminid: adminCookie,
              userid: userCookie,
            }),
          })
            .then(function (response) {
              if (response.status === 400) {
                throw Error("Wrong credentials");
              }
              if (response === 500) {
                throw Error("Could not complete request because of an error");
              }

              return response.json();
            })
            .then((user) => {
              if (user[0].id >= 1) {
                setFoundErr(null);

                setIsLoading(null);
                setContacts(user);
                // loadAnalysis(user);

                //load data
              } else {
                //dont load

                setFoundErr(null);
                setIsLoading(null);
              }
            })
            .catch((err) => {
              // setFoundErr(err.message);
              setIsLoading(null);
              // setFlag(1);
            });
        }, 2000);
      } else {
        setIsLoading(null);
      }
    } catch (error) {}
  };

  //load profile
  const fetchProfile = () => {
    let adminCookie = "";
    adminCookie = Cookies.get("sessionidadmin");
    let userid = "";
    userid = Cookies.get("sessioniduser");
    if (adminCookie.length >= 1 || userid.length >= 1) {
      setIsLoading(true);
      setTimeout(() => {
        fetch("https://api.terraweb.africa/loadProfile", {
          method: "post",
          headers: { "Content-Type": "application/JSON" },
          body: JSON.stringify({
            adminid: adminCookie,
            userid: userid,
          }),
        })
          .then(function (response) {
            if (response.status === 400) {
              throw Error("Wrong credentials");
            }
            if (response === 500) {
              throw Error("Could not complete request because of an error");
            }

            return response.json();
          })
          .then((user) => {
            if (user[0].username.length >= 1) {
              //load data

              setFoundErrAdd(null);

              setIsLoading(null);
              setContacts(user);

              setSuccess(null);
              setDeleteState(null);

              //store a name after load to display in the title of the users table
              setNames((names) => ({
                ...names,
                company: user[0].company,
              }));
            } else {
              //dont load

              setFoundErrAdd(null);
              setFoundErr(null);
              setIsLoading(null);
              setDeleteState(null);
            }
          })
          .catch((err) => {
            // setFoundErr(err.message);
            setIsLoading(null);
            // setFlag(1);
          });
      }, 150);
    } else {
      setIsLoading(null);
    }
  };

  //check if user exists when full name is typed out
  const fetchUsers = () => {};

  // const handleAddFormChange = (event) => {
  //   event.preventDefault();

  //   const fieldName = event.target.getAttribute("name");
  //   const fieldValue = event.target.value;

  //   const newFormData = { ...addFormData };
  //   newFormData[fieldName] = fieldValue;

  //   setAddFormData(newFormData);
  // };

  //temp handle add form change
  const handleAddFormChange = (event) => {
    event.preventDefault();

    setSuccess(null);
    setFoundErrAdd(null);

    const fieldName = event.target.getAttribute("name");
    let fieldValue = event.target.value;

    // Check if the field name is "company" and apply formatting if needed
    if (fieldName === "company") {
      // Ensure the first letter is capitalized
      fieldValue = fieldValue.charAt(0).toUpperCase() + fieldValue.slice(1);

      // Remove trailing white spaces
      fieldValue = fieldValue.trim();
      setAddFormData((prevState) => ({
        ...prevState,
        company: fieldValue,
      }));
    } else if (fieldName === "firstName") {
      // Handle input changes for first name
      if (/^[A-Za-z]+$/.test(fieldValue) || fieldValue === "") {
        const fullName = formatFullName(fieldValue, addFormData.firstName);

        setAddFormData((prevState) => ({
          ...prevState,
          firstName: fieldValue,
          fullname: fullName,
        }));
      }
    } else if (fieldName === "lastName") {
      // Handle input changes for last name
      if (/^[A-Za-z]+$/.test(fieldValue) || fieldValue === "") {
        const fullName = formatFullName(addFormData.firstName, fieldValue);
        setAddFormData((prevState) => ({
          ...prevState,
          lastName: fieldValue,
          fullname: fullName,
        }));
      }
    } else {
      const newFormData = { ...addFormData };
      newFormData[fieldName] = fieldValue;

      setAddFormData(newFormData);
    }
  };

  //handle company input
  const onCompanyChange = (event) => {
    if (names.company.length >= 3) {
      //   setFlag(1);
    } else {
      //   setFlag(2);
    }
    // Spreading "...state" ensures we don't "lose" fname,lname,email... etc
    setNames((names) => ({
      ...names,
      company: event.target.value,
    }));
  };

  const handleEditFormChange = (event) => {
    event.preventDefault();

    const fieldName = event.target.getAttribute("name");

    const fieldValue = event.target.value;

    const newFormData = { ...editFormData };
    newFormData[fieldName] = fieldValue;

    setEditFormData(newFormData);
  };

  //refresh after add records
  const refreshRecords = () => {
    fetchRecords();
  };

  const handleAddFormSubmit = (event) => {
    event.preventDefault();

    const newContact = {
      farmerid: addFormData.farmerid,
      companyname: addFormData.company,
      producttype: addFormData.producttype,
      weight: addFormData.weight,
      fullname: addFormData.fullname,
    };

    if (
      newContact.companyname.length >= 3 &&
      newContact.producttype.length >= 3 &&
      newContact.fullname.length >= 3 &&
      newContact.weight.length >= 1

      // companyname &&
      // companyname.length >= 1 &&
      // producttype &&
      // producttype.length >= 1 &&
      // fullname &&
      // fullname.length >= 1 &&
      // weight &&
      // weight.length >= 1
    ) {
      //send add agent request
      let adminCookie = Cookies.get("sessionidadmin");
      if (adminCookie.length >= 4) {
        setIsLoadingAdd(true);
        setTimeout(() => {
          fetch("https://api.terraweb.africa/addnewrecord", {
            method: "post",
            headers: { "Content-Type": "application/JSON" },
            body: JSON.stringify({
              adminid: adminCookie,
              farmerid: newContact.farmerid,
              producttype: newContact.producttype,
              weight: newContact.weight,
              fullname: newContact.fullname,
              companyname: newContact.companyname,
            }),
          })
            .then(function (response) {
              if (response.status === 400) {
                throw Error("An error occurred while adding records. ");
              }
              if (response === 500) {
                throw Error("Could not complete request because of an error");
              }

              return response.json();
            })
            .then((user) => {
              if (user) {
                setFoundErr(null);

                setIsLoadingAdd(null);
                // setContacts(user);
                setSuccessAdd(user);
                //refresh data
                refreshRecords();

                //load data
              } else {
                //dont load

                setFoundErrAdd(null);
                setIsLoadingAdd(null);
                // addFormData.fullname = "";
              }
            })
            .catch((err) => {
              setFoundErrAdd(err.message);
              setIsLoadingAdd(null);
              // newContact.fullname = "";

              // setFlag(1);
            });
        }, 1000);
      } else {
        setIsLoadingAdd(null);
      }
    }
  };

  const handleEditFormSubmit = (event) => {
    event.preventDefault();

    const editedContact = {
      id: editFormData.id,
      companyname: editFormData.companyname,
      producttype: editFormData.producttype,
      weight: editFormData.weight,

      fullname: editFormData.fullname,
      daterecorded: editFormData.daterecorded,
    };

    const newContacts = [...contacts];

    const index = contacts.findIndex((contact) => contact.id === editContactId);

    newContacts[index] = editedContact;

    // setContacts(newContacts);
    // setEditContactId(null);

    //update

    let adminCookie = Cookies.get("sessionidadmin");
    if (adminCookie.length >= 1) {
      setIsLoadingSave(true);
      setTimeout(() => {
        fetch("https://api.terraweb.africa/updateRecord", {
          method: "post",
          headers: { "Content-Type": "application/JSON" },
          body: JSON.stringify({
            id: newContacts[index].id,
            adminid: adminCookie,
            fullname: newContacts[index].fullname,
            companyname: newContacts[index].companyname,
            producttype: newContacts[index].producttype,
            weight: newContacts[index].weight,
          }),
        })
          .then(function (response) {
            if (response.status === 400) {
              throw Error(
                "An error occurred, during update. Try checking the details to make sure they are correct and try again"
              );
            }
            if (response === 500) {
              throw Error("Could not complete request because of an error.");
            }

            return response.json();
          })
          .then((user) => {
            if (user[0].id >= 1) {
              setFoundErr(null);

              setIsLoadingSave(null);

              refreshRecords();
              setEditContactId(null);
              //load data
            } else {
              //dont load

              setFoundErrAdd(null);
              setIsLoadingSave(null);
              // addFormData.username = "";
            }
          })
          .catch((err) => {
            setFoundErrAdd(err.message);
            setIsLoadingSave(null);

            // setFlag(1);
          });
      }, 1000);
    } else {
      setIsLoadingSave(null);
    }
  };

  const handleEditClick = (event, contact) => {
    event.preventDefault();
    setEditContactId(contact.id);

    const formValues = {
      id: contact.id,
      companyname: contact.companyname,
      producttype: contact.producttype,
      weight: contact.weight,
      fullname: contact.fullname,
      daterecorded: contact.daterecorded,
    };

    setEditFormData(formValues);
  };

  const handleCancelClick = () => {
    setEditContactId(null);
  };

  //confirm delete record
  const onDeleteYes = (id) => {
    let adminCookie = Cookies.get("sessionidadmin");
    if (adminCookie.length >= 1) {
      fetch("https://api.terraweb.africa/deleterecord", {
        method: "post",
        headers: { "Content-Type": "application/JSON" },
        body: JSON.stringify({
          adminid: adminCookie,

          id: id,
        }),
      })
        .then(function (response) {
          if (response.status === 400) {
            throw Error("An error occurred, during delete.");
          }
          if (response === 500) {
            throw Error("Could not complete request because of an error");
          }

          return response.json();
        })
        .then((user) => {
          if (user) {
            refreshRecords();
          } else {
            //dont load
          }
        })
        .catch((err) => {
          // setFlag(1);
        });
    } else {
    }
  };

  const handleDeleteClick = (contactemail) => {
    //delete alert
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="deletediv bg-white br3 bb b--black-10  gold pa2 w-100 shadow-5 center ">
            <h1>Confirm Delete Record</h1>
            <p className="f3 black">Sure you want to delete this user record with ID: {contactemail}?</p>
            <p className="b red f4">
              Note that this cannot be <b className="red f3">UNDONE</b>
            </p>
            <label
              className="dib w3 tc pa2 f3 ma2 white br-pill bg-red hover-bg-white hover-black "
              onClick={onClose}
            >
              No
            </label>
            <label
              className="dib w6 f5 fr tc pa3 white br-pill bg-blue hover-bg-red hover-white"
              onClick={() => {
                onDeleteYes(contactemail);
                onClose();
              }}
            >
              Yes, Delete it!
            </label>
          </div>
        );
      },
    });
  };

  //handle autofill first name and last name
  const handleAutofillNames = () => {};

  // Function to clear the foundFarmer state
  const clearFoundFarmer = () => {
    setFoundFarmer(null); // You can set it to null or an empty object, depending on your use case
  };

  //handle look up farmer id improved by AI
  const handleLookupFarmerID = async (event) => {
    event.preventDefault();

    try {
      const newContact = {
        farmerid: addFormData.farmerid,
      };

      if (newContact.farmerid.length >= 1) {
        setIsLoadingAdd(true);

        const adminCookie = Cookies.get("sessionidadmin");

        if (adminCookie && adminCookie.length >= 4) {
          const response = await fetch(
            "https://api.terraweb.africa/lookupFarmerProfile",
            {
              method: "post",
              headers: { "Content-Type": "application/JSON" },
              body: JSON.stringify({
                adminid: adminCookie,
                farmerid: newContact.farmerid,
              }),
            }
          );

          if (response.status === 400) {
            throw new Error("An error occurred while adding records.");
          }
          if (response === 500) {
            throw new Error(
              "Could not complete the request because of an error."
            );
          }
          //parse the json object sent by the server
          // const data = await response.json();

          //recieve the response as plain text and no need to parse it
          const message = await response.text();

          if (message) {
            setFoundErr(null);
            setIsLoadingAdd(null);

            setFoundFarmer(message);

            // Extract first and last names
            // const fullName = data.message.split(": ")[1];
            // const [firstName, lastName] = fullName.split(" ");
            // setFirstName(firstName);
            // setLastName(lastName);
          } else {
            setFoundErrAdd(null);
            setIsLoadingAdd(null);
            setFoundFarmer(null);
          }
        }
      }
    } catch (err) {
      setFoundErrAdd(err.message);
      setIsLoadingAdd(null);
      setFoundFarmer(null);
    }
  };

  //handle download per row receipt
  const handleDownloadRow =(contact)=>{
handlePrint(contact)

  }
  const getReceiptText = (data) => {
      // let adminCookie = Cookies.get("sessionidadmin");
    
    const now = new Date();
    const formattedDate = now.toLocaleDateString("en-KE", {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    const formattedTime = now.toLocaleTimeString("en-KE");
    const user = "TWAdmin"

    const printedBy = user?.name || "Admin";

    return `
    Terraweb.africa                 
    --------------------------------------------------------------------
    Printed On: ${formattedDate} at ${formattedTime}
    Printed By: ${printedBy}
    --------------------------------------------------------------------
    Company: ${data.companyname}
    --------------------------------------------------------------------
    Receipt ID: ${data.id}
    Username: ${data.fullname}
    Farmer ID: ${data.farmerid}
    Weight: ${data.weight}
    ---------------------------------------------------------------------
    Total: ${data.weight}
    ---------------------------------------------------------------------
    Thank you for choosing Our Company.
    We Value You.
    `;
  };

  const handlePrint = (contact) => {
    const receiptText = getReceiptText(contact);
    const printer = new ClassPrinter();
    printer.print(receiptText);
  };

//handle download table

const handleDownloadTable = () => {
  const doc = new jsPDF();

  const currentDate = new Date().toLocaleString();

  // Header
  doc.setFontSize(16);
  doc.text('Terraweb.africa', 14, 15);
  doc.setFontSize(11);
  doc.text('Empowering farmers through technology', 14, 22);
  doc.setFontSize(10);
  doc.text(`Generated on: ${currentDate}`, 14, 28);

  // Table data
  const tableColumn = [
    'ID',
    'Farmer ID',
    'Product Type',
    'Weight',
    'Company',
    'Full Name',
    'Recorded',
  ];
   
  const tableRows = contacts?.map((contact) => [
    contact.id,
    contact.farmerid,
    contact.producttype,
    contact.weight,
    contact.companyname,
    contact.fullname,
    contact.daterecorded,
  ]) || [];

  autoTable(doc, {
    head: [tableColumn],
    body: tableRows,
    startY: 35,
    styles: { fontSize: 9 , color:"black"},
    headStyles: { fillColor: [252, 156, 28] },
    margin: { top: 35, bottom: 20 },
    didDrawPage: function (data) {
      // Footer
      const pageCount = doc.internal.getNumberOfPages();
      doc.setFontSize(9);
      doc.text(
        `Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`,
        data.settings.margin.left,
        doc.internal.pageSize.height - 10
      );

      // Footer text
      doc.text(
        '© Terraweb.africa — All rights reserved.',
        data.settings.margin.left + 70,
        doc.internal.pageSize.height - 10
      );
    },
  });

  // Save PDF
  doc.save('farmer_records.pdf');
};



//pagination next
const handlePageNext = ()=>{

}

const handlePagePrevious = ()=>{

}

  // //handle look up farmer id
  // const handleLookupFarmerID = (event) => {
  //   event.preventDefault();

  //   const newContact = {
  //     farmerid: addFormData.farmerid,
  //   };

  //   if (
  //     newContact.farmerid.length >= 1

  //     // companyname &&
  //     // companyname.length >= 1 &&
  //     // producttype &&
  //     // producttype.length >= 1 &&
  //     // fullname &&
  //     // fullname.length >= 1 &&
  //     // weight &&
  //     // weight.length >= 1
  //   ) {
  //     //send add agent request
  //     let adminCookie = Cookies.get("sessionidadmin");
  //     if (adminCookie.length >= 4) {
  //       setIsLoadingAdd(true);
  //       setTimeout(() => {
  //         fetch("https://api.terraweb.africa/lookupFarmerProfile", {
  //           method: "post",
  //           headers: { "Content-Type": "application/JSON" },
  //           body: JSON.stringify({
  //             adminid: adminCookie,
  //             farmerid: newContact.farmerid,
  //           }),
  //         })
  //           .then(function (response) {
  //             if (response.status === 400) {
  //               throw Error("An error occurred while adding records. ");
  //             }
  //             if (response === 500) {
  //               throw Error("Could not complete request because of an error");
  //             }

  //             return response.json();
  //           })
  //           .then((data) => {
  //             // //display the found
  //             // // Assuming data contains the response from the server
  //             // const { message } = data; // Extract the message
  //             // const fullName = message.split(": ")[1]; // Extract the full name

  //             // const [firstName, lastName] = fullName.split(" "); // Split full name into first and last names

  //             // console.log(firstName); // First name
  //             // console.log(lastName); // Last name

  //             if (data) {
  //               setFoundErr(null);

  //               setIsLoadingAdd(null);
  //               // setContacts(data);
  //               setSuccessAdd(data);
  //               //refresh data
  //               //display found farmer
  //               setFoundFarmer(data);
  //               console.log(data);

  //               refreshRecords();

  //               //load data
  //             } else {
  //               //dont load

  //               setFoundErrAdd(null);
  //               setIsLoadingAdd(null);
  //               // addFormData.fullname = "";
  //               setFoundFarmer(null);
  //             }
  //           })

  //           .catch((err) => {
  //             // setFoundErrAdd();
  //             setIsLoadingAdd(null);
  //             // newContact.fullname = "";
  //             setFoundFarmer(null);

  //             // setFlag(1);
  //           });
  //       }, 1000);
  //     } else {
  //       setIsLoadingAdd(null);
  //     }
  //   }
  // };

  return (
    <div className="records-app-container center mt6  ">
      {isLoading ? (
        <div className="db mb2">
          <Circles type="Oval" color="#000080" height={40} width={80} />
        </div>
      ) : null}

      <div className="dib-l ">
        <div className="controlContainer center d-grid bg-white  br4 shadow-3 w-100">
          <div>
          <label className="ma2 black pa2 f3 b">
            Total Weight
            <label className="strong red ml2 mr2 pa2">{totalRecords?totalRecords:""}</label>
          </label>

    
          <label className="ma2 pt3 black f3 b">
            My Records
                   <label className="strong red ml2 mr2 pa2">{totalRecords?totalRecords:""}</label>

          </label>
          </div>
          <div className="grid-item  ">
            <input
              type="text"
              className="searchInput "
              placeholder="Search farmer Record"
              onChange={onSearchChange}
            />

        
             <label className="pa1 hover-bg-transparent"onClick={searchRecords}>
            <i className="fas fa-search f2 hover-gold orange"></i>
            <span className=""></span>
          </label>
          </div>
          <div className="grid-item ">
            <label className="f3  ">
              Showing <b>1-50</b> of <b> {contacts.length} </b>Entries
            </label>
            {/* <button
              className=" br-pill bw0 ml2 bg-white orange f4  b pa2 hover-bg-orange hover-white"
              type="submit"
              onClick={handleAddFormSubmit}
            >
              back
            </button> */}
            {/* <button
              // className=" br-pill bw0 ml2 bg-white orange f4  b pa2 hover-bg-orange hover-white"
              className=" fas fa-caret-left f2 hover-gold"
              type="submit"
              onClick={handleAddFormSubmit}
            >
              next
            </button> */}
            <label className="pa3 hover-bg-transparent" onClick={handlePagePrevious}>
            <i className="fas fa-caret-left f2 hover-gold"></i>
            <span className=""></span>
          </label>
            <label className="pa3 hover-bg-transparent" onClick={handlePageNext}>
            <i className="fas fa-caret-right f2 hover-gold"></i>
            <span className=""></span>
          </label>
            <label className="pa3 hover-bg-transparent" onClick={handleDownloadTable}>
            <i className="fas fa-download f2 hover-gold"></i>
            <span className=""></span>
          </label>
          </div>
        </div>
      </div>
      <form onSubmit={handleEditFormSubmit}>
        <table>
          <thead  >
            <tr >
              <th className="bg-gold">ID</th>
              <th className="bg-gold">Farmer ID</th>
              <th className="bg-gold">Product Type</th>
              <th className="bg-gold">Weight</th>
              <th className="bg-gold">Company</th>
              <th className="bg-gold">Full Name</th>

              <th className="bg-gold">Recorded</th>
              <th className="bg-gold">Edit records</th>
            </tr>
          </thead>
          <tbody>
            {contacts.map((contact) => (
              <Fragment key={contact.id}>
                {editContactId === contact.id ? (
                  <EditableRow
                    handleEditFormSubmit={handleEditFormSubmit}
                    isLoadingSave={isLoadingSave}
                    editFormData={editFormData}
                    handleEditFormChange={handleEditFormChange}
                    handleCancelClick={handleCancelClick}
                    handleDownloadRow={handleDownloadRow}
                  />
                ) : (
                  <ReadOnlyRow
                    contact={contact}
                    handleEditClick={handleEditClick}
                    handleDeleteClick={handleDeleteClick}
                    handleDownloadRow={handleDownloadRow}

                  />
                )}
              </Fragment>
            ))}
          </tbody>
        </table>
      </form>
      <div>
        {foundErr ? <label className="dt red  pb2">{foundErr}</label> : null}

        <button
          className="ml2 br-pill bg-white orange f3 pa3 b mt2 hover-bg-orange hover-white"
          onClick={refreshRecords}
        >
          Refresh
        </button>
      </div>
  {/* <div className="recordsdiv">
      <h2 className="f3 b gold ">Add New Record</h2>
    
       
        <h2>
          <b className="b f3 black">Choose the company</b>
        </h2>
        <select
          className="rounded f3 bg-white tracked br-pill w-90 w-25-l"
          value={names.company}
          onChange={onCompanyChange}
        >

       <option value="">-- Choose a company --

              
               </option>
                {(Array.isArray(companiesList) ? companiesList : []).map((company, idx) => (
                <option key={idx} value={company.name}>
                  {company.name}
               </option>
                ))}
        </select>

        <h2 className="b black f3 ma2">Farmer ID</h2>

        <input
          // key={index}
          className="b black tl"
          type="text"
          name="farmerid"
          defaultValue={names.farmerid}
          // required="required"
          placeholder="Enter Farmer ID"
          // placeholder={names.company}
          onChange={handleAddFormChange}
        />
        <label
          className=" br-pill bg-white orange f4  b ma2 pa3 hover-bg-orange hover-white"
          onClick={handleLookupFarmerID}
        >
          Lookup ID
        </label>
        {foundFarmer ? (
          <div className="br-pill bg-white w-25">
            <label onClick={clearFoundFarmer} className="dt green f3 b  pa2">
              {foundFarmer}
            </label>
          </div>
        ) : null}

        <div>
          <h2 className="b black f3 ma2">
            <b className="b black f3 ma2">First Name</b>
          </h2>

          <input
            // ref={firstnameref}
            className=" tl"
            placeholder="First Name"
            type="text"
            name="firstName"
            // value={addFormData.firstName}
            onChange={handleAddFormChange}
          />
        </div>
        <div>
          <h2 className="b black f3 ma2">
            <b className="b black f3 ma2">Last Name</b>
          </h2>
          <input
            // ref={lastnameref}
            className="tl"
            placeholder="Last Name"
            name="lastName"
            type="text"
            // value={addFormData.lastName}
            onChange={handleAddFormChange}
          />
        </div>
        <select
          className="rounded pa2 ma2 f4 bg-white tracked br-pill w-25-l w-25-m"
          value={names.producttype}
          onChange={onProducttypeChange}
          name="producttype"
        >
          {options.map((option) => (
            <option key={option.value} value={option.value}>
              {option.text}
            </option>
          ))}
        </select>
        <input
          className="br-pill"
          type="number"
          name="weight"
          placeholder="Enter weight (Kgs)"
          onChange={handleAddFormChange}
        />
        {isLoadingAdd ? (
          <div className="dib pa3">
            <Circles type="Oval" color="#000080" height={30} width={40} />
          </div>
        ) : null}
        <label
          className=" br-pill bg-white orange f4  b pa2 hover-bg-orange hover-white"
          onClick={handleAddFormSubmit}
        >
          Add
        </label>
        {successAdd ? (
          <div className="br-pill bg-white w-25">
            <label className="dt green f3 b  pa2">{successAdd}</label>
          </div>
        ) : null}
        {foundErrAdd ? (
          <label className="dt red f3 b  pb2">{foundErrAdd}</label>
        ) : null}
        <div className="bg-white shadow-3  pa2 br4">
          <label className="f3 b black ">Note:</label>
          <label className="f3 b black">
            You can only add or edit a record for a farmer that belongs to your
            designated company.
          </label>
        </div>
      </div> */}

      {/* improved */}
      <div className="recordsdiv">
  <h2 className="f3 b gold">Add New Record</h2>

  <div className="form-grid">
    {/* Company selection */}
    <div>
      <label className="b f5 db mb2">Choose the company</label>
      <select
        className=""
        value={names.company}
        onChange={onCompanyChange}
      >
        <option value="">-- Choose a company --</option>
        {(Array.isArray(companiesList) ? companiesList : []).map((company, idx) => (
          <option key={idx} value={company.name}>{company.name}</option>
        ))}
      </select>
    </div>

    {/* Farmer ID + Lookup */}
    <div>
      <label className="b f5 db mb2">Farmer ID</label>
      <input
        type="text"
        name="farmerid"
        defaultValue={names.farmerid}
        placeholder="Enter Farmer ID"
        onChange={handleAddFormChange}
      />
      <label
        className="br-pill bg-white orange f6 b mt2 pa2 hover-bg-orange hover-white dib"
        onClick={handleLookupFarmerID}
      >
        Lookup ID
      </label>
    </div>

    {/* Optional lookup result */}
    {foundFarmer && (
      <div className="br-pill bg-light-green pa2">
        <label onClick={clearFoundFarmer} className="f6 b green">
          {foundFarmer}
        </label>
      </div>
    )}

    {/* First Name */}
    <div>
      <label className="b f5 db mb2">First Name</label>
      <input
        type="text"
        name="firstName"
        placeholder="First Name"
        onChange={handleAddFormChange}
      />
    </div>

    {/* Last Name */}
    <div>
      <label className="b f5 db mb2">Last Name</label>
      <input
        type="text"
        name="lastName"
        placeholder="Last Name"
        onChange={handleAddFormChange}
      />
    </div>

    {/* Product type */}
    <div>
      <label className="b f5 db mb2">Product Type</label>
      <select
        className=""
        value={names.producttype}
        name="producttype"
        onChange={onProducttypeChange}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.text}
          </option>
        ))}
      </select>
    </div>

    {/* Weight */}
    <div>
      <label className="b f5 db mb2">Weight (kg)</label>
      <input
        type="number"
        name="weight"
        placeholder="Enter weight"
        onChange={handleAddFormChange}
      />
    </div>
  </div>

  {/* Button + loading */}
  <div className="mt3">
    {isLoadingAdd ? (
      <div className="dib pa3">
        <Circles type="Oval" color="#000080" height={30} width={40} />
      </div>
    ) : (
      <label
        className="br-pill bg-orange white f5 b pa2 hover-bg-orange hover-white pointer dib"
        onClick={handleAddFormSubmit}
      >
        Add
      </label>
    )}
  </div>

  {/* Success/Error states */}
  {successAdd && (
    <div className="br-pill bg-light-green pa2 mt2">
      <label className="f5 green b">{successAdd}</label>
    </div>
  )}
  {foundErrAdd && (
    <label className="f5 red b db mt2">{foundErrAdd}</label>
  )}

  {/* Footer note */}
  <div className="bg-white shadow-3 pa3 br4 mt3">
    <label className="f5 b black db mb1">Note:</label>
    <span className="f5 black">
      You can only add or edit a record for a farmer that belongs to your designated company.
    </span>
  </div>
</div>

    </div>
  );
};

export default TwRecords;
